module.exports = __webpack_public_path__ + "img/mobile-banner-2-image.096cf09b.png";